import { registerComponent, createMessage, loading } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "customer-survey",
  class CustomerSurvey extends WYATTElement {
    constructor() {
      super();

      this.customerNumber = this.urlParams.get("c");
      this.recieptNumber = this.urlParams.get("r");
      this.transactionId = this.urlParams.get("t");
      this.storeNumber = this.urlParams.get("s");
    }

    connectedCallback() {
      if (this.customerNumber) {
        this.renderSurvey();

        return;
      }

      this.renderPreSurvey();
    }

    get urlParams() {
      return new URLSearchParams(window.location.search);
    }

    get surveyId() {
      return this.config.surveyId;
    }

    get surveyParams() {
      const params = new URLSearchParams();

      if (this.customerNumber) {
        params.set("typeform-medium=embed-snippet#c", this.customerNumber);
      }

      if (this.storeNumber) {
        params.set("s", this.storeNumber);
      }

      if (this.recieptNumber) {
        params.set("r", this.recieptNumber);
      }

      if (this.transactionId) {
        params.set("t", this.transactionId);
      }

      return params.toString();
    }

    renderSurvey() {
      const surveyTemplate = this.querySelector("[data-survey]");
      const survey = surveyTemplate.content.cloneNode(true);
      const element = survey.querySelector("[data-url]");

      element.dataset.url = `https://form.typeform.com/to/${this.surveyId}?${this.surveyParams}`;

      this.appendChild(survey);
    }

    renderPreSurvey() {
      const preSurveyTemplate = this.querySelector("[data-pre-survey]");
      const preSurvey = preSurveyTemplate.content.cloneNode(true);
      this.modal = preSurvey.querySelector("wyatt-modal");
      this.form = preSurvey.querySelector("form");

      this.setupForm();
      this.appendChild(preSurvey);
    }

    setupForm() {
      const storeNumberInput = this.form.querySelector("[name='store-number']");
      const receiptNumberInput = this.form.querySelector(
        "[name='receipt-number']",
      );

      storeNumberInput.value = this.storeNumber;
      receiptNumberInput.value = this.recieptNumber;

      this.form.addEventListener(
        "submit",
        this.handlePreSurveySubmit.bind(this),
      );
    }

    async handlePreSurveySubmit(event) {
      event.preventDefault();

      const formData = new FormData(event.target);

      this.storeNumber = formData.get("store-number");
      this.recieptNumber = formData.get("receipt-number");

      try {
        loading.add(this.form);

        const response = await fetch(
          `/${WYATT.proxy_url.url}/${WYATT.proxy_url.identifier}/erply/customer_survey?storeNumber=${this.storeNumber}&invoiceNumber=${this.recieptNumber}`,
        );
        const data = await response.json();

        this.customerNumber = data.c;
        this.recieptNumber = data.r;
        this.storeNumber = data.s;
        this.transactionId = data.t;

        if (!this.transactionId) {
          createMessage(this.config.t.unableToFindTransaction, {
            type: "error",
            appendPoint: ".customer-survey__pre-survey-form [data-validation]",
          });
          return;
        }

        this.renderSurvey();
        this.modal.close();
      } catch {
        createMessage(this.config.t.unableToFindTransaction, {
          type: "error",
          appendPoint: ".customer-survey__pre-survey-form [data-validation]",
        });
      } finally {
        loading.remove(this.form);
      }
    }
  },
);
